import { useEffect, useState } from "react";
import { Alert, Progress, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import ApiService from "../../core/service/api-service";
import { normalizeReAssessmentFilter } from "./re-assessment-filter-query";

/**
 * İlk okuyan doktora göre kırılım.
 *
 * Sayının anlamı konusunda ekranda açık uyarı var: sonucu ("değişti / aynı kaldı") raporu ONAYLAYAN
 * kullanıcı seçiyor ve bu çoğu kurulumda doktorun kendisi değil. Tablo, kapatan kullanıcının
 * beyanının ilk okuyan doktora atfedilmiş hâlidir — doktorun kendi beyanı değildir.
 */
export default function ReAssessmentStats({ filter }) {
    const { t } = useTranslation();

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        if (!filter) return;

        setLoading(true);
        try {
            const response = await ApiService.ReAssessment.GetStatistics(normalizeReAssessmentFilter(filter));
            if (response.success) {
                setRows(response.data || []);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, [JSON.stringify(filter)]);

    const columns = [
        {
            title: t('Original Read User'),
            dataIndex: 'originalReadUserName',
            key: 'originalReadUserName',
            render: (text) => text || t('Unspecified'),
        },
        { title: t('Total'), dataIndex: 'total', key: 'total', width: 110 },
        {
            title: t('Report Changed'),
            dataIndex: 'changed',
            key: 'changed',
            width: 150,
            render: (value) => <Tag color={value > 0 ? 'red' : 'default'}>{value}</Tag>,
        },
        {
            title: t('Report Unchanged'),
            dataIndex: 'unchanged',
            key: 'unchanged',
            width: 150,
            render: (value) => <Tag color={value > 0 ? 'green' : 'default'}>{value}</Tag>,
        },
        {
            title: t('Open'),
            dataIndex: 'open',
            key: 'open',
            width: 110,
            render: (value) => <Tag color={value > 0 ? 'orange' : 'default'}>{value}</Tag>,
        },
        {
            title: t('Change Rate'),
            dataIndex: 'changeRate',
            key: 'changeRate',
            width: 200,
            render: (value) => (value === null || value === undefined)
                ? '-'
                : <Progress percent={Number(value)} size={'small'} status={'normal'} />,
        },
    ];

    return (
        <>
            <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message={t('The result is selected by the user who confirms the report, which is often not the doctor. These numbers are attributed to the doctor who read the first version.')}
            />
            <Table
                rowKey={(record) => record.originalReadUserId || 'unspecified'}
                size={'small'}
                loading={loading}
                columns={columns}
                dataSource={rows}
                pagination={false}
            />
        </>
    );
}
